webpackJsonp([69949351783210],{

/***/ 283:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contactCard":"src-components-contactCard----contactCard-module---contactCard---1TYXY","imageContainer":"src-components-contactCard----contactCard-module---imageContainer---1QNFB"};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(11);
	
	var _contactCardModule = __webpack_require__(283);
	
	var _contactCardModule2 = _interopRequireDefault(_contactCardModule);
	
	var _index = __webpack_require__(20);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactCard = function ContactCard(_ref) {
	  var title = _ref.title,
	      visitingAddress = _ref.visitingAddress,
	      phoneNumber = _ref.phoneNumber,
	      mailAddress = _ref.mailAddress,
	      sizes = _ref.sizes,
	      image = _ref.image;
	  return _react2.default.createElement(
	    'div',
	    { className: _contactCardModule2.default.contactCard },
	    _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ),
	    _react2.default.createElement(_index2.default, {
	      outerWrapperClassName: _contactCardModule2.default.imageContainer,
	      sizes: sizes,
	      src: image,
	      alt: title
	    }),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'map-pin'] }),
	        visitingAddress
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'phone'] }),
	        phoneNumber
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'envelope'] }),
	        mailAddress
	      )
	    )
	  );
	};
	
	ContactCard.propTypes = {
	  title: _propTypes2.default.string,
	  visitingAddress: _propTypes2.default.string,
	  phoneNumber: _propTypes2.default.string,
	  mailAddress: _propTypes2.default.string,
	  sizes: _propTypes2.default.shape({}),
	  image: _propTypes2.default.string
	};
	
	exports.default = ContactCard;
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-danger */
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	/* eslint-enable react/no-danger */
	
	var Content = function Content(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.responsibleDisclosurePageQuery = exports.ResponsibleDisclosurePageTemplate = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _responsibleDisclosurePageModule = __webpack_require__(297);
	
	var _responsibleDisclosurePageModule2 = _interopRequireDefault(_responsibleDisclosurePageModule);
	
	var _index = __webpack_require__(195);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _helperFunctions = __webpack_require__(25);
	
	var _index3 = __webpack_require__(196);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsibleDisclosurePageTemplate = exports.ResponsibleDisclosurePageTemplate = function ResponsibleDisclosurePageTemplate(_ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      visitingAddress = _ref.visitingAddress,
	      phoneNumber = _ref.phoneNumber,
	      mailAddress = _ref.mailAddress,
	      content = _ref.content,
	      imageSizes = _ref.imageSizes;
	
	  var PageContent = _index3.HTMLContent || _index4.default;
	
	  return _react2.default.createElement(
	    'main',
	    { className: _responsibleDisclosurePageModule2.default.responsibleDisclosurePage },
	    _react2.default.createElement(
	      'section',
	      { className: _responsibleDisclosurePageModule2.default.left },
	      _react2.default.createElement(PageContent, { content: content })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: _responsibleDisclosurePageModule2.default.right },
	      _react2.default.createElement(_index2.default, {
	        title: title,
	        visitingAddress: visitingAddress,
	        phoneNumber: phoneNumber,
	        mailAddress: mailAddress,
	        sizes: (0, _helperFunctions.findImageSizes)(image, imageSizes),
	        image: image
	      })
	    )
	  );
	};
	
	ResponsibleDisclosurePageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired,
	  visitingAddress: _propTypes2.default.string,
	  phoneNumber: _propTypes2.default.string,
	  mailAddress: _propTypes2.default.string,
	  content: _propTypes2.default.string,
	  imageSizes: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	var ResponsibleDisclosurePage = function ResponsibleDisclosurePage(_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	  var imageSizes = data.imageSizes.edges;
	
	  return _react2.default.createElement(ResponsibleDisclosurePageTemplate, {
	    title: post.frontmatter.contactInfo.title,
	    image: post.frontmatter.contactInfo.image,
	    visitingAddress: post.frontmatter.contactInfo.visitingAddress,
	    phoneNumber: post.frontmatter.contactInfo.phoneNumber,
	    mailAddress: post.frontmatter.contactInfo.mailAddress,
	    content: post.html,
	    imageSizes: imageSizes
	  });
	};
	
	ResponsibleDisclosurePage.propTypes = {
	  data: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = ResponsibleDisclosurePage;
	var responsibleDisclosurePageQuery = exports.responsibleDisclosurePageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"responsibleDisclosurePage":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---responsibleDisclosurePage---17CD8","left":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---left---2z1NP","right":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---right---39rd3"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-responsible-disclosure-page-index-js-3b134369866f34b66558.js